/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "views/LayoutContainers/DashboardLayout";
import DashboardNavbar from "views/Navbars/DashboardNavbar";
import Footer from "views/Footer";

// Project page components
import Header from "layouts/pages/events/components/Header";
import booking1 from "assets/images/products/product-1-min.jpg";
// Images
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import team5 from "assets/images/team-5.jpg";
import EventCard from "../../../../views/Cards/EventCard";
import { Tooltip } from "@mui/material";
import { useGetAllEventsQuery } from "../../../../store/api/events";
import Moment from "moment";
import { Link } from "react-router-dom";
import { useMeQuery } from "../../../../store/api/auth";

function AllEvents() {
  // Action buttons for the BookingCard
  const actionButtons = (id) => (
    <>
      {user && user.subscription.length > 0 && (<>
        <Tooltip title="Upload" placement="bottom">
        <MDTypography
          variant="body1"
          color="primary"
          lineHeight={1}
          sx={{ cursor: "pointer", mx: 3 }}
        >
          <Link to={id + "/gallery"}>
            <Icon color="inherit">photograph</Icon>
          </Link>
        </MDTypography>
      </Tooltip>
        <Tooltip title="Edit" placement="bottom">
        <MDTypography variant="body1" color="info" lineHeight={1} sx={{cursor: "pointer", mx: 3}}>
        <Link to={"edit/"+id}>
        <Icon color="inherit">edit</Icon>
        </Link>
        </MDTypography>
        </Tooltip></>)}
      <Tooltip title="Detail" placement="bottom">
        <MDTypography variant="body1" color="info" lineHeight={1} sx={{ cursor: "pointer", mx: 3 }}>
          <Link to={''+id}>
            <Icon color="inherit">double_arrow</Icon>
          </Link>
        </MDTypography>
      </Tooltip>
    </>
  );


  const [currentEvent, setCurrentEvent] = useState(null);
  const [draftEvent, setDraftEvent] = useState(null);
  const [outdatedEvent, setOutdatedEvent] = useState(null);
  const [showEvent, setShowEvent] = useState(null);
  const { data, error, isLoading } = useGetAllEventsQuery();
  const [activeTab, setActiveTab] = useState(0);
  const { data: user } = useMeQuery();

  useEffect(() => {
    if (data) {
      const curr = data.data.filter(e => e.status === 4);
      const outd = data.data.filter(e => e.status === 3);
      const draft = data.data.filter(e => e.status === 0);
      setCurrentEvent(curr);
      setOutdatedEvent(outd);
      setDraftEvent(draft);
      if(user && user.subscription.length === 0){
        setActiveTab(1)
      }
      if (activeTab === 0) {
        setShowEvent(draft);
      } else if (activeTab === 1) {
        setShowEvent(curr);
      } else if (activeTab === 2) {
        setShowEvent(outd);
      }

    }
  }, [data]);

  useEffect(()=>{
    setShowEvent(draftEvent);
  },[draftEvent]);

  useEffect(() => {
    if (activeTab === 0) {
      setShowEvent(draftEvent);
    } else if (activeTab === 1) {
      setShowEvent(currentEvent);
    } else if (activeTab === 2) {
      setShowEvent(outdatedEvent);
    }
  }, [activeTab]);

  return (
    <DashboardLayout>
      <MDBox width="calc(100% - 48px)" position="absolute" top="1.75rem">
        <DashboardNavbar light absolute />
      </MDBox>
      <Header setActiveTab={setActiveTab} />
      <MDBox pb={3}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={7}>
            <MDBox mb={1}>
              <MDTypography variant="h5">Events</MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" color="text">
                {user && user.subscription.length > 0 ? "You can create or edit events here." : "Global or your events (membership includes)"}
              </MDTypography>
            </MDBox>
          </Grid>
          {user && user.subscription.length > 0 && (<Grid item xs={12} md={5} sx={{textAlign: "right"}}>
            <Link to="new">
              <MDButton variant="gradient" color="info">
                <Icon>add</Icon>&nbsp; Add New
              </MDButton>
            </Link>
          </Grid>)}
        </Grid>
        <MDBox mt={2}>
          <Grid container spacing={3}>
            {
              showEvent && showEvent.map(e =>
                <Grid key={e.id} item xs={12} md={6} lg={4}>
                  <MDBox mt={3}>
                    <EventCard
                      image={e.cover}
                      title={e.name ? e.name : ""}
                      description={e.description ? e.description : ""}
                      location={e.state ? e.state : "" + ", " + e.city ? e.city : ""}
                      action={actionButtons(e.id)}
                      dateTime={e.end_date ? Moment(e.end_date).format("DD-MM-YYYY") : ""}
                      members={e.event_members}
                      participant_count={e.participant_count}
                    />
                  </MDBox>
                </Grid>
              )
            }
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AllEvents;
